import axios from 'axios';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { Search, QuestionGame, QuestionGameUser, QuestionGameVoteType, getConfiguration } from '../models';

export const getQuestionGameUsers = AwesomeDebouncePromise(async (search: Search): Promise<QuestionGame> => {
    const result = await axios(
        `${getConfiguration().serviceEndpoint}/dotnet/question/webservice.asmx/Landing`,
        {
            withCredentials: true,
            params: {
                ageFrom: search.ageFrom,
                ageTo: search.ageTo,
                sex: (search.genderFemale && search.genderMale) || (search.genderFemale === false && search.genderMale === false) ? 0 : search.genderFemale ? 1 : 2,
                location: search.location.id,
            },
        }
    );
    return result.data;
}, 300);

export const questionGameVote = async (vote: QuestionGameVoteType, valentineId: number, otherValentineId: number, ageFrom: number, ageTo: number, sex: number, location: string): Promise<QuestionGameUser> => {
    console.log(ageFrom);
    console.log(sex);
    const result = await axios(
        `${getConfiguration().serviceEndpoint}/dotnet/question/webservice.asmx/LandingVote`,
        {
            withCredentials: true,
            params: {
                vote: vote,
                valentineId: valentineId,
                otherValentineId: otherValentineId ?? 0,
                ageFrom,
                ageTo,
                sex,
                location,
            },
        }
    );
    return result.data;
};